var $9dd86690a5c2b2c5$exports = {};
$9dd86690a5c2b2c5$exports = {
  "deselectedItem": function deselectedItem(args) {
    return "Vienums ".concat(args.item, " nav atlas\u012Bts.");
  },
  "longPressToSelect": "Ilgi turiet nospiestu. lai iesl\u0113gtu atlases re\u017E\u012Bmu.",
  "select": "Atlas\u012Bt",
  "selectedAll": "Atlas\u012Bti visi vienumi.",
  "selectedCount": function selectedCount(args, formatter) {
    return "".concat(formatter.plural(args.count, {
      "=0": "Nav atlas\u012Bts neviens vienums",
      one: function one() {
        return "Atlas\u012Bto vienumu skaits: ".concat(formatter.number(args.count));
      },
      other: function other() {
        return "Atlas\u012Bto vienumu skaits: ".concat(formatter.number(args.count));
      }
    }), ".");
  },
  "selectedItem": function selectedItem(args) {
    return "Atlas\u012Bts vienums ".concat(args.item, ".");
  }
};
export { $9dd86690a5c2b2c5$exports as default };